import { Builder4ra56zvvku0a as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { withContextqz5k6d9p9xx5 as withContext } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Builder3d75eph7uovs3 as Builder_0 } from './network/http/HttpNetworkTransport.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Builder1suvx83rlbrz1 as Builder_1 } from './network/websocket/WebSocketNetworkTransport.mjs';
import {
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance_0,
  toDurationba1nlt78o6vu as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Builder3moivcm5iuump as Builder_2 } from './network/ws/WebSocketNetworkTransport.mjs';
import { get_defaultDispatcher3rblue9uzsji2 as get_defaultDispatcher } from './internal/dispatchers.js.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  cancel36mj9lv3a0whl as cancel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ConcurrencyInfo3mmnli95yq2g0 as ConcurrencyInfo } from './ConcurrencyInfo.mjs';
import { NetworkInterceptor22fszyorwx7pt as NetworkInterceptor } from './interceptor/NetworkInterceptor.mjs';
import { ApolloCallpwdxdy18rzuy as ApolloCall } from './ApolloCall.mjs';
import { channelFlow1or0c85tk04v1 as channelFlow } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RetryOnErrorInterceptor2wqvvqzzzk2ot as RetryOnErrorInterceptor } from './interceptor/RetryOnErrorInterceptor.mjs';
import { DefaultInterceptorChain10weji0clzo5q as DefaultInterceptorChain } from './interceptor/ApolloInterceptor.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder_3() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.y5y_1 = new (Builder())();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.z5y_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.a5z_1 = ArrayList().p2();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.b5z_1 = ArrayList().p2();
        var tmp_2 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_2.c5z_1 = ArrayList().p2();
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_3.d5z_1 = ArrayList().p2();
        this.e5z_1 = this.d5z_1;
        this.f5z_1 = Companion_getInstance().b40_1;
        this.g5z_1 = null;
        this.h5z_1 = null;
        this.i5z_1 = null;
        this.j5z_1 = null;
        this.k5z_1 = null;
        this.l5z_1 = null;
        this.m5z_1 = null;
        this.n5z_1 = null;
        this.o5z_1 = null;
        this.p5z_1 = null;
        this.q5z_1 = null;
        this.r5z_1 = null;
        this.s5z_1 = null;
        this.t5z_1 = null;
        this.u5z_1 = null;
        this.v5z_1 = null;
        this.w5z_1 = null;
        this.x5z_1 = null;
        this.y5z_1 = null;
        this.z5z_1 = null;
        this.a60_1 = null;
        this.b60_1 = null;
        this.c60_1 = null;
        this.d60_1 = null;
        this.e60_1 = null;
        this.f60_1 = true;
      }
      g60() {
        return this.y5y_1.i37();
      }
      h60() {
        return plus(plus(plus(this.z5y_1, this.a5z_1), this.b5z_1), this.c5z_1);
      }
      q40(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.f60_1 = sendEnhancedClientAwareness;
        return this;
      }
      p40(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.c60_1 = failFastIfOffline;
        return this;
      }
      i60(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.a60_1 = retryOnError;
        return this;
      }
      j60(retryOnErrorInterceptor) {
        // Inline function 'kotlin.apply' call
        this.b60_1 = retryOnErrorInterceptor;
        return this;
      }
      k60(cacheInterceptor) {
        // Inline function 'kotlin.apply' call
        this.d60_1 = cacheInterceptor;
        return this;
      }
      l60(autoPersistedQueryInterceptor) {
        // Inline function 'kotlin.apply' call
        this.e60_1 = autoPersistedQueryInterceptor;
        return this;
      }
      f40(url) {
        // Inline function 'kotlin.apply' call
        this.g5z_1 = url;
        return this;
      }
      g40(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.h5z_1 = httpMethod;
        return this;
      }
      h40(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.i5z_1 = httpHeaders;
        return this;
      }
      j40(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.j5z_1 = sendApqExtensions;
        return this;
      }
      k40(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.k5z_1 = sendDocument;
        return this;
      }
      l40(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.l5z_1 = enableAutoPersistedQueries;
        return this;
      }
      m40(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.m5z_1 = canBeBatched;
        return this;
      }
      n40(ignoreUnknownKeys) {
        // Inline function 'kotlin.apply' call
        this.n5z_1 = ignoreUnknownKeys;
        return this;
      }
      m60(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.r5z_1 = serverUrl;
        return this;
      }
      n60(httpServerUrl) {
        // Inline function 'kotlin.apply' call
        this.r5z_1 = httpServerUrl;
        return this;
      }
      o60(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.s5z_1 = httpEngine;
        return this;
      }
      p60(httpExposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.w5z_1 = httpExposeErrorBody;
        return this;
      }
      q60(httpInterceptors) {
        // Inline function 'kotlin.apply' call
        this.d5z_1.a5();
        this.d5z_1.u2(httpInterceptors);
        return this;
      }
      r60(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.t5z_1 = webSocketServerUrl;
        return this;
      }
      s60(webSocketServerUrl) {
        // Inline function 'kotlin.apply' call
        this.z5z_1 = webSocketServerUrl;
        return this;
      }
      t60(webSocketIdleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.u5z_1 = webSocketIdleTimeoutMillis;
        return this;
      }
      u60(wsProtocolFactory) {
        // Inline function 'kotlin.apply' call
        this.v5z_1 = wsProtocolFactory;
        return this;
      }
      v60(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.x5z_1 = webSocketEngine;
        return this;
      }
      w60(webSocketReopenWhen) {
        // Inline function 'kotlin.apply' call
        this.y5z_1 = webSocketReopenWhen;
        return this;
      }
      x60(networkTransport) {
        // Inline function 'kotlin.apply' call
        this.o5z_1 = networkTransport;
        return this;
      }
      y60(subscriptionNetworkTransport) {
        // Inline function 'kotlin.apply' call
        this.p5z_1 = subscriptionNetworkTransport;
        return this;
      }
      z60(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.y5y_1.a5();
        this.y5y_1.m45(customScalarAdapters);
        return this;
      }
      a61(dispatcher) {
        // Inline function 'kotlin.apply' call
        this.q5z_1 = dispatcher;
        return this;
      }
      d40(executionContext) {
        // Inline function 'kotlin.apply' call
        this.f5z_1 = executionContext;
        return this;
      }
      i37() {
        return new (ApolloClient())(this.d38());
      }
      d38() {
        // Inline function 'kotlin.also' call
        var this_0 = (new (Builder_3())()).z60(this.y5y_1.i37());
        this_0.z5y_1.u2(this.z5y_1);
        this_0.a5z_1.u2(this.a5z_1);
        this_0.b5z_1.u2(this.b5z_1);
        this_0.c5z_1.u2(this.c5z_1);
        return this_0.a61(this.q5z_1).d40(this.f5z_1).f40(this.g5z_1).g40(this.h5z_1).h40(this.i5z_1).n60(this.r5z_1).o60(this.s5z_1).p60(this.w5z_1).q60(this.e5z_1).j40(this.j5z_1).k40(this.k5z_1).l40(this.l5z_1).m40(this.m5z_1).n40(this.n5z_1).x60(this.o5z_1).y60(this.p5z_1).r60(this.t5z_1).s60(this.z5z_1).v60(this.x5z_1).w60(this.y5z_1).t60(this.u5z_1).u60(this.v5z_1).i60(this.a60_1).j60(this.b60_1).k60(this.d60_1).l60(this.e60_1).p40(this.c60_1).q40(this.f60_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_3);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.b61_1 = function_0;
      }
      *v1d(value, $completion) {
        return yield* this.b61_1(value, $completion);
      }
      i5() {
        return this.b61_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow) {
  return constructCallableReference(function *(it, $completion) {
    yield* $this_channelFlow.b1b(it, $completion);
    return Unit_instance;
  }, 1);
}
function ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this_channelFlow) {
  return constructCallableReference(function *($this$withContext, $completion) {
    var tmp = this$0.c61($apolloRequest, $throwing);
    var tmp_0 = ApolloClient$executeAsFlowInternal$slambda$slambda$slambda($this_channelFlow);
    yield* tmp.y1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp_0), $completion);
    return Unit_instance;
  }, 1);
}
function ApolloClient$executeAsFlowInternal$slambda(this$0, $apolloRequest, $throwing) {
  return constructCallableReference(function *($this$channelFlow, $completion) {
    yield* withContext(this$0.b5y_1.d61_1, ApolloClient$executeAsFlowInternal$slambda$slambda(this$0, $apolloRequest, $throwing, $this$channelFlow), $completion);
    return Unit_instance;
  }, 1);
}
function ApolloClient$apolloResponses$slambda() {
  return constructCallableReference(function *(response, $completion) {
    var tmp;
    if (!(response.f42_1 == null)) {
      throw ensureNotNull(response.f42_1);
    }
    return Unit_instance;
  }, 1);
}
var ApolloClientClass;
function ApolloClient() {
  if (ApolloClientClass === VOID) {
    class $ {
      constructor(builder) {
        this.a5y_1 = builder;
        this.e5y_1 = this.a5y_1.h60();
        this.f5y_1 = this.a5y_1.g60();
        this.g5y_1 = this.a5y_1.d60_1;
        this.h5y_1 = this.a5y_1.e60_1;
        this.i5y_1 = this.a5y_1.a60_1;
        this.j5y_1 = this.a5y_1.b60_1;
        this.k5y_1 = this.a5y_1.c60_1;
        this.l5y_1 = this.a5y_1.f60_1;
        this.m5y_1 = this.a5y_1.f5z_1;
        this.n5y_1 = this.a5y_1.g5z_1;
        this.o5y_1 = this.a5y_1.h5z_1;
        this.p5y_1 = this.a5y_1.i5z_1;
        this.q5y_1 = this.a5y_1.j5z_1;
        this.r5y_1 = this.a5y_1.k5z_1;
        this.s5y_1 = this.a5y_1.l5z_1;
        this.t5y_1 = this.a5y_1.m5z_1;
        this.u5y_1 = this.a5y_1.n5z_1;
        var tmp = this;
        var tmp_0;
        if (!(this.a5y_1.o5z_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.r5z_1 == null)) {
            var message = "Apollo: 'httpServerUrl' has no effect if 'networkTransport' is set. Configure httpServerUrl on the networkTransport directly.";
            throw IllegalStateException().o(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.s5z_1 == null)) {
            var message_0 = "Apollo: 'httpEngine' or 'okHttpClient' has no effect if 'networkTransport' is set. Configure httpEngine on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_0));
          }
          // Inline function 'kotlin.check' call
          if (!this.a5y_1.e5z_1.n1()) {
            var message_1 = "Apollo: 'addHttpInterceptor' has no effect if 'networkTransport' is set. Configure the interceptors on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_1));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.w5z_1 == null)) {
            var message_2 = "Apollo: 'httpExposeErrorBody' has no effect if 'networkTransport' is set. Configure httpExposeErrorBody on the networkTransport directly.";
            throw IllegalStateException().o(toString(message_2));
          }
          tmp_0 = ensureNotNull(this.a5y_1.o5z_1);
        } else {
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder_0())()).m61(this.a5y_1.r5z_1);
          if (!(this.a5y_1.s5z_1 == null)) {
            this_0.n61(ensureNotNull(this.a5y_1.s5z_1));
          }
          if (!(this.a5y_1.w5z_1 == null)) {
            this_0.o61(ensureNotNull(this.a5y_1.w5z_1));
          }
          tmp_0 = this_0.p61(this.a5y_1.e5z_1).i37();
        }
        tmp.c5y_1 = tmp_0;
        var tmp_1 = this;
        var tmp_2;
        if (!(this.a5y_1.p5z_1 == null)) {
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.t5z_1 == null)) {
            var message_3 = "Apollo: 'webSocketServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_3));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.x5z_1 == null)) {
            var message_4 = "Apollo: 'webSocketEngine' or 'okHttpClient' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketEngine on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_4));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.u5z_1 == null)) {
            var message_5 = "Apollo: 'webSocketIdleTimeoutMillis' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketIdleTimeoutMillis on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_5));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.v5z_1 == null)) {
            var message_6 = "Apollo: 'wsProtocolFactory' has no effect if 'subscriptionNetworkTransport' is set. Configure wsProtocolFactory on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_6));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.y5z_1 == null)) {
            var message_7 = "Apollo: 'webSocketReopenWhen' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenWhen on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_7));
          }
          // Inline function 'kotlin.check' call
          if (!(this.a5y_1.z5z_1 == null)) {
            var message_8 = "Apollo: 'webSocketReopenServerUrl' has no effect if 'subscriptionNetworkTransport' is set. Configure webSocketReopenServerUrl on the subscriptionNetworkTransport directly.";
            throw IllegalStateException().o(toString(message_8));
          }
          tmp_2 = ensureNotNull(this.a5y_1.p5z_1);
        } else {
          var tmp0_elvis_lhs = this.a5y_1.t5z_1;
          var url = tmp0_elvis_lhs == null ? this.a5y_1.r5z_1 : tmp0_elvis_lhs;
          var tmp_3;
          if (url == null) {
            tmp_3 = this.c5y_1;
          } else if (!(this.a5y_1.x5z_1 == null) || !(this.a5y_1.v5z_1 == null) || !(this.a5y_1.y5z_1 == null) || !(this.a5y_1.z5z_1 == null)) {
            // Inline function 'kotlin.apply' call
            var this_1 = (new (Builder_2())()).m60(url);
            if (!(this.a5y_1.x5z_1 == null)) {
              this_1.g62(ensureNotNull(this.a5y_1.x5z_1));
            }
            if (!(this.a5y_1.u5z_1 == null)) {
              this_1.h62(ensureNotNull(this.a5y_1.u5z_1));
            }
            if (!(this.a5y_1.v5z_1 == null)) {
              this_1.i62(ensureNotNull(this.a5y_1.v5z_1));
            }
            if (!(this.a5y_1.y5z_1 == null)) {
              this_1.j62(this.a5y_1.y5z_1);
            }
            if (!(this.a5y_1.z5z_1 == null)) {
              this_1.k62(this.a5y_1.z5z_1);
            }
            tmp_3 = this_1.i37();
          } else {
            // Inline function 'kotlin.apply' call
            var this_2 = (new (Builder_1())()).m61(url);
            if (!(this.a5y_1.u5z_1 == null)) {
              Companion_getInstance_0();
              // Inline function 'kotlin.time.Companion.milliseconds' call
              var this_3 = ensureNotNull(this.a5y_1.u5z_1);
              var tmp$ret$26 = toDuration(this_3, DurationUnit_MILLISECONDS_getInstance());
              this_2.y61(tmp$ret$26);
            }
            tmp_3 = this_2.i37();
          }
          tmp_2 = tmp_3;
        }
        tmp_1.d5y_1 = tmp_2;
        var tmp1_elvis_lhs = this.a5y_1.q5z_1;
        var dispatcher = tmp1_elvis_lhs == null ? get_defaultDispatcher() : tmp1_elvis_lhs;
        this.b5y_1 = new (ConcurrencyInfo())(dispatcher, CoroutineScope(dispatcher));
        this.v5y_1 = new (NetworkInterceptor())(this.c5y_1, this.d5y_1);
      }
      l62(query) {
        return ApolloCall().y5x(this, query);
      }
      m62(mutation) {
        return ApolloCall().y5x(this, mutation);
      }
      l6() {
        cancel(this.b5y_1.e61_1);
        this.c5y_1.sz();
        this.d5y_1.sz();
      }
      w5y(apolloRequest, throwing) {
        var flow = channelFlow(ApolloClient$executeAsFlowInternal$slambda(this, apolloRequest, throwing));
        return buffer(flow, 2147483647);
      }
      c61(apolloRequest, throwing) {
        var apolloClient = this;
        // Inline function 'kotlin.apply' call
        var this_0 = apolloRequest.j41();
        this_0.d40(this.b5y_1.w41(this.f5y_1).w41(apolloClient.m5y_1).w41(this_0.m3z_1));
        var tmp0_elvis_lhs = this_0.o3z_1;
        this_0.g40(tmp0_elvis_lhs == null ? apolloClient.o5y_1 : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this_0.r3z_1;
        this_0.j40(tmp1_elvis_lhs == null ? apolloClient.q5y_1 : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this_0.s3z_1;
        this_0.k40(tmp2_elvis_lhs == null ? apolloClient.r5y_1 : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this_0.q3z_1;
        this_0.l40(tmp3_elvis_lhs == null ? apolloClient.s5y_1 : tmp3_elvis_lhs);
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_1 = ArrayList().p2();
        if (!(this_0.v3z_1 === true)) {
          // Inline function 'kotlin.collections.orEmpty' call
          var tmp0_elvis_lhs_0 = apolloClient.p5y_1;
          var tmp$ret$6 = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
          this_1.u2(tmp$ret$6);
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = this_0.p3z_1;
        var tmp$ret$7 = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        this_1.u2(tmp$ret$7);
        var headers = this_1.f8();
        this_0.h40(headers);
        var tmp4_elvis_lhs = this_0.t3z_1;
        var canBeBatched = tmp4_elvis_lhs == null ? apolloClient.t5y_1 : tmp4_elvis_lhs;
        if (!(canBeBatched == null)) {
          this_0.i40('X-APOLLO-CAN-BE-BATCHED', canBeBatched.toString());
        }
        var tmp5_elvis_lhs = this_0.w3z_1;
        var tmp;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = apolloClient.i5y_1;
          tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver(apolloRequest);
        } else {
          tmp = tmp5_elvis_lhs;
        }
        this_0.o40(tmp);
        var tmp7_elvis_lhs = this_0.x3z_1;
        this_0.p40(tmp7_elvis_lhs == null ? apolloClient.k5y_1 : tmp7_elvis_lhs);
        var tmp8_elvis_lhs = this_0.u3z_1;
        this_0.n40(tmp8_elvis_lhs == null ? apolloClient.u5y_1 : tmp8_elvis_lhs);
        this_0.q40(apolloClient.l5y_1);
        var tmp9_elvis_lhs = this_0.n3z_1;
        this_0.f40(tmp9_elvis_lhs == null ? apolloClient.n5y_1 : tmp9_elvis_lhs);
        var request = this_0.i37();
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_2 = ArrayList().p2();
        this_2.u2(this.a5y_1.z5y_1);
        if (!(this.g5y_1 == null)) {
          this_2.i2(this.g5y_1);
        }
        this_2.u2(this.a5y_1.a5z_1);
        if (!(this.h5y_1 == null)) {
          this_2.i2(this.h5y_1);
        }
        this_2.u2(this.a5y_1.b5z_1);
        var tmp0_elvis_lhs_2 = this.j5y_1;
        this_2.i2(tmp0_elvis_lhs_2 == null ? RetryOnErrorInterceptor() : tmp0_elvis_lhs_2);
        this_2.u2(this.a5y_1.c5z_1);
        this_2.i2(this.v5y_1);
        var allInterceptors = this_2.f8();
        // Inline function 'kotlin.let' call
        var it = (new (DefaultInterceptorChain())(allInterceptors, 0)).p62(request);
        var tmp_0;
        if (throwing) {
          tmp_0 = onEach(it, ApolloClient$apolloResponses$slambda());
        } else {
          tmp_0 = it;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'ApolloClient');
    ApolloClientClass = $;
  }
  return ApolloClientClass;
}
//region block: exports
export {
  Builder_3 as Builder3lcn00uc5gcy3,
};
//endregion

//# sourceMappingURL=ApolloClient.mjs.map
